import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button } from 'react-bootstrap';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const OrganizationActions = require('../../actions/OrganizationActions');
const OrganizationMemberStore = require('../../stores/OrganizationMemberStore');
const ProjectStore = require('../../stores/ProjectStore');
const SignInStore = require('../../stores/SignInStore');

import ConfirmModal from '../modal/ConfirmModal';
import AccessibleIcon from '../common/AccessibleIcon';
import OrgRoleDropdown from '../common/OrgRoleDropdown';
import Tooltip from '../common/Tooltip';
import OrgMemberProjectPermissions from './OrgMemberProjectPermissions';

const propTypes = {
    userPermissions: PropTypes.object,
    user: PropTypes.object,
    orgId: PropTypes.number.isRequired,
    backHandler: PropTypes.func.isRequired
};

const defaultProps = {
    userPermissions: {}
};

class OrganizationMemberEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            signInStoreState: SignInStore.getState(),
            organizationMemberStoreState: OrganizationMemberStore.getState(),
            editActionId: null,
            removeActionId: null,
            confirmRemoveUserModalState: false,
            updatedRoleToken: null
        }

        this.removeUser = this.removeUser.bind(this);
        this.onRoleChange = this.onRoleChange.bind(this);
        this.updateUser = this.updateUser.bind(this);
        this.unsubscribes = [
            OrganizationMemberStore.listen(this.onOrgMemberStoreChange.bind(this)),
            SignInStore.listen(this.onStoreChange.bind(this, "signInStoreState")),
        ];
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onStoreChange(storeStateName, state) {
        this.setState({ [storeStateName]: state });
    }

    onOrgMemberStoreChange(state) {
        let additionalState = {};
        if (state.action.id === this.state.removeActionId && !state.action.error) {
            this.props.backHandler();
            return;
        }
        else if (state.action.id === this.state.editActionId && !state.action.error) {
            additionalState = { ...additionalState, editActionId: null, updatedRoleToken: null };
        }

        this.setState({ organizationMemberStoreState: state, ...additionalState });
    }

    removeUser(e) {
        const actionId = uuid.v4();
        this.setState({removeActionId: actionId, confirmRemoveUserModalState: false}, () => {
            OrganizationActions.removeOrganizationMember(actionId, {
                orgId: this.props.orgId,
                userId: this.props.user.id
            });
        });
    }

    updateUser(e) {
        const actionId = uuid.v4();
        this.setState({ editActionId: actionId }, () => {
            OrganizationActions.setOrganizationPermission(actionId, {
                orgId: this.props.orgId,
                email: this.props.user.email,
                role: this.state.updatedRoleToken
            });
        });
    }

    onRoleChange(roleToken) {
        this.setState({ updatedRoleToken: roleToken });
    }

    toggleConfirmRemoveUserModal(showBool) {
        this.setState({ confirmRemoveUserModalState: showBool });
    }

    render() {
        const defaultPortrait = GlobalConfig.StaticUrl + "/img/default-user-portrait.svg";

        return (
            <div>
                <div className="channelHeadingFlex">
                    <div className="channelHeadingFlex__heading">
                        <button
                            className="btn btn-primary glyph btn-circle btn-lg margin-right-15"
                            onClick={this.props.backHandler}
                            title={Strings['en'].common.BACK}
                        >
                            <AccessibleIcon label={Strings['en'].common.BACK}>
                                <span className="fa fa-chevron-left" aria-hidden={true} />
                            </AccessibleIcon>
                        </button>
                        <h2 className="heading-lg">{this.props.heading}</h2>
                    </div>
                </div>
                {(!!this.props.user) &&
                    <div className="tile-dash-floating user-profile">
                        <Row>
                            <div className="col-12 col-sm-3 user-portrait-col">
                                <img src={defaultPortrait} alt={Strings['en'].organization.USER_PORTRAIT_ALT} className="user-portrait" />
                            </div>
                            <div className="col-12 col-sm-9 user-info-col">
                                {(!this.props.user.unverified) ?
                                    <div className="user-name">
                                        {this.props.user.first_name + " " + this.props.user.last_name}
                                    </div>
                                    :
                                    <div className="user-name">
                                        {Strings['en'].organization.PENDING_MEMBER}
                                        <Tooltip
                                            id="verification-tip"
                                            className="margin-left-sm"
                                            placement="right"
                                        >
                                            {Strings['en'].organization.PENDING_MEMBER_TT}
                                        </Tooltip>
                                    </div>
                                }

                                {(!this.props.user.unverified) &&
                                    <div>
                                        <label htmlFor="display-name">{Strings['en'].user.profile.DISPLAY}</label>
                                        <div className="user-info-item" id="display-name">{this.props.user.display_name}</div>
                                    </div>
                                }

                                <label htmlFor="email">{Strings['en'].user.profile.EMAIL}</label>
                                <div className="user-info-item" id="email">{this.props.user.email}</div>

                                <label htmlFor="org-role-edit">{Strings['en'].organization.ROLE}</label>
                                {(this.props.userPermissions.manageLevel && !this.props.user.permissions.isChannelOwner && this.state.signInStoreState.userInfo.id !== this.props.user.id) ?
                                    <div>
                                        <OrgRoleDropdown
                                            id="org-role-edit"
                                            selectedRoleToken={this.state.updatedRoleToken || this.props.user.role_token}
                                            onRoleChange={this.onRoleChange}
                                            includeGuest
                                        />
                                    </div>
                                    :
                                    <div id="org-role-edit" className="user-info-item">{this.props.user.role_display_name}</div>
                                }

                                {(this.props.userPermissions.manageLevel && !this.props.user.permissions.isChannelOwner && this.state.signInStoreState.userInfo.id !== this.props.user.id) &&
                                    <div className="margin-top-md">
                                        <Button
                                            disabled={!this.state.updatedRoleToken || !!this.state.editActionId || !!this.state.removeActionId}
                                            onClick={this.updateUser}
                                        >
                                            {Strings['en'].common.UPDATE}
                                        </Button>
                                    </div>
                                }

                                <OrgMemberProjectPermissions
                                    user={this.props.user}
                                    orgId={this.props.orgId}
                                    ownUserId={this.state.signInStoreState.userInfo.id}
                                    ownUserPermissions={this.props.userPermissions}
                                />

                                {(this.props.userPermissions.removeUser && !this.props.user.permissions.isChannelOwner && this.state.signInStoreState.userInfo.id !== this.props.user.id) &&
                                    <div className="margin-top-md">
                                        <Button
                                            variant="danger"
                                            onClick={this.toggleConfirmRemoveUserModal.bind(this, true)}
                                        >
                                            <span className="fa fa-remove margin-right-sm" aria-hidden="true" />
                                            {Strings['en'].organization.REMOVE_FROM_ORG}
                                        </Button>
                                    </div>
                                }
                            </div>
                        </Row>
                    </div>
                }

                {(this.state.confirmRemoveUserModalState) &&
                    <ConfirmModal
                        show
                        modalTitle={Strings['en'].organization.remove_user_modal.TITLE}
                        text={Strings['en'].organization.remove_user_modal.TEXT}
                        buttonText={Strings['en'].organization.remove_user_modal.CONFIRM_BTN_LBL}
                        closeHandler={this.toggleConfirmRemoveUserModal.bind(this, false)}
                        confirmHandler={this.removeUser}
                        confirmButtonBsStyle="danger"
                    />
                }
            </div>
        );
    }
}

OrganizationMemberEdit.propTypes = propTypes;
OrganizationMemberEdit.defaultProps = defaultProps;

export default OrganizationMemberEdit;